import LogoutIcon from '@mui/icons-material/Logout';
import {
    Avatar,
    Container,
    Divider,
    MenuItem,
    MenuList,
    Typography
} from '@mui/material';
import { UserProfileProps } from "@propTypes/index";
import { AppBarStyle } from '../../../customStyles';

const UserProfile: React.FC<UserProfileProps> = ({ userRole, handleLogout, handleOpenDisplaySettings, closeUserSettings, userGivenName, userFamilyName, userInitials }) => {
    let formatUserRole = userRole?.split("_");
    const handleKeyDown = (event) => {
        if (event.key === 'Escape' || event.key === 'Tab') {
            closeUserSettings()
        }
    };

    return (
        <MenuList sx={{ zIndex: 3 }} onKeyDown={handleKeyDown}>
            <MenuItem sx={{ padding: "0px", pointerEvents: 'none' }} data-testid="user-menu-item">
                <Container disableGutters sx={AppBarStyle.userProfileName}>
                    <Avatar sx={{ backgroundColor: '#64646B' }} alt="Avatar with the user's initials" variant="circular">
                        <Typography variant='body1' color='#FFF'>{userInitials}</Typography>
                    </Avatar>
                    <Container maxWidth={false} disableGutters sx={AppBarStyle.userProfileRole}>
                        <Typography variant="body1" color='text.primary'>
                            {`${userGivenName} ${userFamilyName}`}
                        </Typography>
                        {formatUserRole?.length > 3 ?
                            <div>
                                <Typography variant="body2" color='text.secondary' sx={{ textDecoration: 'wrap' }}>
                                    {`${formatUserRole[0]}_${formatUserRole[1]}_`}
                                </Typography>
                                <Typography variant="body2" color='text.secondary' sx={{ textDecoration: 'wrap' }}>
                                    {`${formatUserRole[2]}_${formatUserRole[3]}`}
                                </Typography>
                            </div>
                            :
                            <Typography variant="body2" color='text.secondary' sx={{ wordWrap: 'break-word', wordBreak: "break-word", overflowWrap: 'break-word', whiteSpace: 'normal' }}>
                                {userRole}
                            </Typography>
                        }
                    </Container>
                </Container>
            </MenuItem>
            <Divider aria-hidden role="separator" />
            <MenuItem onClick={() => handleOpenDisplaySettings()} data-testid="display-settings-menu-item">
                <Typography variant="body1" color='text.primary'>Display Settings</Typography>
            </MenuItem>
            <Divider aria-hidden role="separator" />
            <MenuItem onClick={() => handleLogout()} sx={{ gap: '0.5rem' }} data-testid="logout-menu-item">
                <LogoutIcon sx={{ color: 'text.secondary' }} fontSize='small' />
                <Typography variant="body1" color='text.primary'>Logout</Typography>
            </MenuItem>
        </MenuList>
    )
}

export default UserProfile;